import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { ReactComponent as ImageExpandIcon } from "assets/icons/image_expand.svg";
import { ReactComponent as ArrowRightIcon } from "assets/icons/slider_arrow_right.svg";
import { ReactComponent as DisableCameraIcon } from "assets/icons/disable_camera.svg";
import CardImageViewerSlider from "./CardImageViewerSlider";
import { ReactComponent as EditIcon } from "assets/icons/edit_pencil.svg";
import useBookmark from "hooks/useBookmark";

const PropertyCardImageSlider = ({
  property,
  isOnMapMini = false,
  isOrganisePage,
  isBookmarked,
  isBookmarkPropertyHasNote,
}) => {
  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageHasError, setImageHasError] = useState(false);
  const { togglePropertyNoteDialog } = useBookmark();

  const settings = {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    navigation: {
      nextEl: `.swiper-${isOnMapMini ? "map-" : "main-"}${
        property.property_id
      }-next`,
      prevEl: `.swiper-${isOnMapMini ? "map-" : "main-"}${
        property.property_id
      }-prev`,
    },
    pagination: !isOnMapMini
      ? {
          clickable: true,
          dynamicBullets: true,
          renderBullet: (index, className) => {
            return `<span class="${className} property_card_swiper_dots">${
              index + 1
            }</span>`;
          },
        }
      : false,
    onSlideChange: (swiper) => {
      setCurrentIndex(swiper.activeIndex);
    },
  };

  const totalSlides = property?.pictures?.length || 0;

  return (
    <div className="overflow-hidden relative">
      {imageHasError ? (
        <div className="w-full bg-[#F9F6F6] object-cover flex items-center justify-center rounded-tl-[8px] rounded-tr-[8px] h-[200px]">
          <DisableCameraIcon />
        </div>
      ) : (
        <>
          <Swiper {...settings}>
            {property?.pictures?.length > 0 &&
              property.pictures.map((image, ind) => (
                <SwiperSlide key={ind}>
                  <img
                    className="w-full object-cover rounded-tl-[8px] rounded-tr-[8px] h-[200px]"
                    src={image}
                    alt="property"
                    onError={() => setImageHasError(true)}
                  />
                </SwiperSlide>
              ))}
          </Swiper>

          {!isOnMapMini && (
            <div
              onClick={() => setIsImageViewerOpen(true)}
              className="bg-white z-[1] rounded-[5px] w-[24px] h-[24px] cursor-pointer shadow-md flex items-center justify-center absolute top-[7px] left-[7px]"
            >
              <ImageExpandIcon />
            </div>
          )}

          {isBookmarked &&
            ((!isOrganisePage && isBookmarkPropertyHasNote) ||
            isOrganisePage ? (
              <div
                onClick={() => togglePropertyNoteDialog(property?._id)}
                className="w-6 h-6 absolute right-[7px] z-[1] top-[7px] rounded-[5px] bg-white cursor-pointer note-btn-shadow flex items-center justify-center"
              >
                <EditIcon
                  className={`${
                    isBookmarkPropertyHasNote
                      ? "text-primary"
                      : "text-[#0000004D]"
                  }`}
                />
              </div>
            ) : null)}

          {isOnMapMini && (
            <div className="bg-[#D9D9D933] rounded-[4px] text-[10px] text-white font-medium z-[1] absolute top-[9px] left-[9px] border border-white p-1">
              {currentIndex + 1}/{totalSlides}
            </div>
          )}

          {isImageViewerOpen && (
            <CardImageViewerSlider
              setIsImageViewerOpen={setIsImageViewerOpen}
              pictures={property?.pictures}
            />
          )}

          {/* Custom Navigation Arrows */}
          <div
            className={`swiper-${isOnMapMini ? "map-" : "main-"}${
              property.property_id
            }-next absolute right-[17px] top-1/2 z-[1] -translate-y-1/2 cursor-pointer`}
          >
            <ArrowRightIcon
              fill="white"
              width={isOnMapMini ? 14 : 17}
              height={isOnMapMini ? 25 : 34}
            />
          </div>
          <div
            className={`swiper-${isOnMapMini ? "map-" : "main-"}${
              property.property_id
            }-prev absolute left-[17px] top-1/2 z-[1] -translate-y-1/2 cursor-pointer rotate-180`}
          >
            <ArrowRightIcon
              fill="white"
              width={isOnMapMini ? 14 : 17}
              height={isOnMapMini ? 25 : 34}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PropertyCardImageSlider;
